import { render } from "./EmptyDialog.vue?vue&type=template&id=ffbce122&scoped=true"
import script from "./EmptyDialog.vue?vue&type=script&lang=js"
export * from "./EmptyDialog.vue?vue&type=script&lang=js"

import "./EmptyDialog.vue?vue&type=style&index=0&id=ffbce122&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbce122"]])

export default __exports__